import { Box, Text } from '@chakra-ui/react';
import { RiLinkedinBoxFill } from 'react-icons/ri';
import React from 'react';

const ContactURL = ({url}) => {
  if(typeof url === 'undefined'  || url === '') {
    return null;
  }
  return (
    <Box className='linkWrapper' >
      <Text className='linkText' ><RiLinkedinBoxFill />  </Text><Text >{url}</Text></Box>
  );
}
export default ContactURL;